import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mask",
  "use": "icon-mask-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-mask\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M21,3.2H3a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V4.2A1,1,0,0,0,21,3.2ZM4,5.62,17.59,19.2H11.41L4,11.79ZM6.41,5.2h6.18L20,12.62v6.17ZM20,9.79,15.41,5.2H20ZM4,14.62,8.59,19.2H4Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol